import React from 'react'

const NotFoundPage = () => {
  return (
    <div className='prep'>
      잘못된 주소입니다...
    </div>
  )
}

export default NotFoundPage
